import { z } from 'zod';

export const adminFeedbackSearchSchema = z.object({
  entityId: z.coerce.string(),
  type: z
    .enum(['excursion', 'accommodation'])
    .catch('accommodation')
    .default('accommodation'),
});
